import queryString from 'query-string'
/**
 *
 * @description 入力した情報をsetAccountするためのonChange
 */
export const setInputUserInformation = (e, account, actions) => {
  const [name, value] = [e.target.name, e.target.value]
  const payload = {}
  if (name === 'acceptTermOfService') {
    payload[name] = !account.acceptTermOfService
  } else if (name === 'acceptTermOfHost') {
    payload[name] = !account.acceptTermOfHost
  } else {
    payload[name] = value
  }
  actions.setAccount(payload)
}

/**
 *
 * @description 新たにゲスト会員登録と、ホスト会員登録をするためのonSubmit
 */
export const submitGuestAndHost = (account, config, restClient, actions) => {
  // 同時登録の時に必須にするためクライアント側でチェックを行う
  if (account.tel === '') {
    let payload = {
      errors: {
        tel: i18n.t('page.formError.tel'),
      },
    }
    return actions.setAccount(payload)
  }

  if (account.acceptTermOfService) {
    const queries = queryString.parse(new URL(config.URL).search)
    const options = {
      done: queries.done,
      serviceId: queries.serviceId,
      referralToken: queries.referred_by || queries.referredBy, // queryパラメータ名はreferredByで渡されてくる
      source: queries.utm_source,
      medium: queries.utm_medium,
      term: queries.utm_term,
      campaign: queries.utm_campaign,
    }
    return actions.hostSignUp({ restClient, account, options })
  } else {
    let payload = {
      errors: {
        accept_term_of_service: i18n.t('page.formError.notAcceptTermOfService'),
      },
    }
    return actions.setAccount(payload)
  }
}

/**
 *
 * @description 既にゲスト会員になっており、新たにホスト会員登録をするためのonSubmit
 */
export const submitHost = (account, config, data, restClient, actions) => {
  if (account.acceptTermOfHost) {
    const queries = queryString.parse(new URL(config.URL).search)
    const options = {
      done: queries.done,
      serviceId: queries.serviceId,
      referralToken: queries.referred_by || queries.referredBy, // queryパラメータ名はreferredByで渡されてくる
      source: queries.utm_source,
      medium: queries.utm_medium,
      term: queries.utm_term,
      campaign: queries.utm_campaign,
    }
    const currentUser = data?.viewer
    return actions.hostSignUp({ restClient, account, options, currentUser })
  } else if (!account.acceptTermOfHost) {
    let payload = {
      errors: {
        accept_term_of_host: i18n.t('page.formError.notAcceptTermOfHost'),
      },
    }
    return actions.setAccount(payload)
  }
}
